import { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';

import type { Company } from '@xing-com/crate-common-graphql-types';

import { CompanyCard } from '../../components/company-card';
import { CompanyCardContainer } from '../../components/company-card-container';
import { FollowButton } from '../../components/follow-button';
import { CompanyCardsSkeletonLoggedin } from '../../components/skeleton';
import { useCompanyData } from '../../hooks/use-company-data/use-company-data';
import { useMostVisitedCompanies } from '../../hooks/use-most-visited-companies';
import { ROUTES } from '../../routes/routes';
import * as Styled from './followed-empty-state.styles';

const Disclaimer = () => {
  return (
    <Styled.EmptyStateCardWrapper>
      <Styled.TextLayer>
        <Styled.Headline size="xxlarge">
          <FormattedMessage id="CP_FOLLOWED_EMPTY_STATE_HEADER" />
        </Styled.Headline>
        <Styled.BodyCopy>
          <FormattedMessage id="CP_FOLLOWED_EMPTY_STATE_SUBHEADER" />
        </Styled.BodyCopy>
      </Styled.TextLayer>
      <Styled.Button
        href={ROUTES.mostVisitedCompanies}
        size="small"
        variant="tertiary"
      >
        <FormattedMessage id="CP_FOLLOWED_EMPTY_STATE_BUTTON" />
      </Styled.Button>
    </Styled.EmptyStateCardWrapper>
  );
};
const FollowedEmptyState = () => {
  const LIMIT = 3;
  const { data, loading } = useMostVisitedCompanies({
    limit: LIMIT,
    offset: 0,
  });
  const { addCompanies } = useCompanyData();

  useEffect(() => {
    if (data?.mostVisitedCompanies?.collection) {
      addCompanies({
        companies: data?.mostVisitedCompanies?.collection?.map(
          (item) => item?.company
        ) as Company[],
      });
    }
  }, [data]);

  if (loading) return <CompanyCardsSkeletonLoggedin />;
  const { collection } = data?.mostVisitedCompanies ?? {};

  return (
    <>
      <Disclaimer />
      <CompanyCardContainer>
        {collection?.map((item, index) => {
          const company = item?.company as Company;
          const isFollowing =
            company?.userContext?.followState?.isFollowing || false;
          return (
            <CompanyCard
              key={company?.id}
              company={company}
              buttons={[
                <FollowButton
                  disabled={company?.entityPageId ? false : true}
                  entityPageId={company?.entityPageId || ''}
                  key={company?.entityPageId}
                  isFollowing={isFollowing}
                  companyId={company?.id}
                  position={index}
                />,
              ]}
            />
          );
        })}
      </CompanyCardContainer>
    </>
  );
};

export { FollowedEmptyState };
